export const CONSIGNMENT_SERVER_STATUS = {
  pending: 'pending',
  auto_reviewed: 'auto_reviewed',
  reviewed: 'reviewed',
  skipped: 'skipped',
  rejected: 'rejected',
} as const

export const US_ONLY_CONSIGNMENT_MESSAGE = 'This consignment is restricted to US-based reviewers'
